"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Col = _interopRequireDefault(require("../Col"));

var _Row = _interopRequireDefault(require("../Row"));

var _excluded = ["background", "bordered", "children", "className", "colSize", "dark", "deep", "includeCol", "element", "light", "rowClassName", "shallow", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Strip = function Strip(_ref) {
  var _classNames;

  var background = _ref.background,
      _ref$bordered = _ref.bordered,
      bordered = _ref$bordered === void 0 ? false : _ref$bordered,
      children = _ref.children,
      className = _ref.className,
      _ref$colSize = _ref.colSize,
      colSize = _ref$colSize === void 0 ? 12 : _ref$colSize,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? false : _ref$dark,
      _ref$deep = _ref.deep,
      deep = _ref$deep === void 0 ? false : _ref$deep,
      _ref$includeCol = _ref.includeCol,
      includeCol = _ref$includeCol === void 0 ? true : _ref$includeCol,
      _ref$element = _ref.element,
      Component = _ref$element === void 0 ? "div" : _ref$element,
      _ref$light = _ref.light,
      light = _ref$light === void 0 ? false : _ref$light,
      rowClassName = _ref.rowClassName,
      _ref$shallow = _ref.shallow,
      shallow = _ref$shallow === void 0 ? false : _ref$shallow,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: (0, _classnames.default)(className, (_classNames = {}, _defineProperty(_classNames, "p-strip--".concat(type), !!type), _defineProperty(_classNames, "p-strip", !type), _defineProperty(_classNames, "is-bordered", bordered), _defineProperty(_classNames, "is-dark", dark), _defineProperty(_classNames, "is-deep", deep), _defineProperty(_classNames, "is-light", light), _defineProperty(_classNames, "is-shallow", shallow), _classNames)),
    style: background && {
      backgroundImage: "url('".concat(background, "')")
    }
  }, props), /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: rowClassName
  }, includeCol ? /*#__PURE__*/_react.default.createElement(_Col.default, {
    size: colSize
  }, children) : children));
};

var _default = Strip;
exports.default = _default;